




























import { Component, Prop, Vue } from 'vue-property-decorator'
import VueFilter from '../../modules/filter/VueFilter'

Vue.filter('number_format', VueFilter.numberFormat)

type DisplayType = 'A' | 'B' | 'C'

@Component
export default class PageRenge extends Vue {
  // ------------------------------------------------------------------------------------------------
  // props

  // 表示開始位置
  @Prop() private offset!: number
  // １ページあたりの表示件数
  @Prop() private size!: number
  // 最大件数
  @Prop() private max!: number
  // 表示タイプ（A,B）
  @Prop({ default: 'A' }) private type!: DisplayType

  // ---------------------------------------------------------------------------
  // computed
  get navhead(): number {
    return this.max > 0 ? this.offset + 1 : 0
  }

  get navend(): number {
    const end = this.offset + this.size
    if (this.max < end) {
      return this.max
    }
    return end
  }
}
